<template>
  <div class="addModel myinput">
    <div>
      <div class="addem">
        <span>名称</span>
        <el-input v-model="name" maxlength="100"></el-input>
      </div>
      <div class="addem">
        <span>EUI</span>
        <el-input v-model="eui" maxlength="100"></el-input>
      </div>
      <div class="addem">
        <span>MQTT主题</span>
        <el-input v-model="mqttApi" maxlength="100"></el-input>
      </div>
    </div>
    <div class="detailed">
      <div class="element-list jb-bg btn" @click="submit">确认</div>
      <div class="element-list jb-bg btn" @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['depotId'],
  data() {
    return {
      name:'',//传感器名称
      eui:'',
      mqttApi: '',
      isAdd:true,
      id: 0,
    };
  },
  created() {
    let item =JSON.parse(sessionStorage.getItem('ThermInfo'))
    if(item && item.id){
      this.isAdd = false
      this.name = item.thermometerName;
      this.eui = item.eui;
      this.mqttApi = item.mqttApi;
      this.id = item.id
    }

  },
  methods: {
    submit() {
      if(this.name.trim() == '' || this.eui.trim() == '' || this.mqttApi.trim() == ''){
         this.$message.error('有内容未填写，请检查！');
      }else{
        let data = {
          name:this.name,
          eui:this.eui,
          mqttApi:this.mqttApi,
          id:this.id,
          depotId:parseInt(sessionStorage.getItem('depotId'))
        };
        let item = JSON.parse(JSON.stringify(data))
        this.$emit("submitTherm", item,this.isAdd);
        this.name = '';
        this.eui = '';
        this.mqttApi='';
      }
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style lang='less' scoped>
//弹框样式
.addModel {
  height: 300px;
  color: #74c8fe;
  margin: 0 30px;
  .addem {
    display: flex;
    height: 60px;
    line-height: 50px;
    margin: 15px 5px;
    .el-input {
      width: 260px;
      margin: 0px 15px;
    }
    span {
      width: 85px;
      text-align: center;
      text-align-last: justify;
    }
    .el-select{
    margin: 0 15px;
  }
  }

  .detailed {
    margin: 0 25px 20px;
    clear: both;
    display: flex;
    position: absolute;
    bottom: 0px;
    .btn {
      width: 150px;
      margin-right: 10px;
      cursor: pointer;
    }

    .element-list {
      border: 2px solid#0090F0;
      border-radius: 6px;
      height: 30px;
      line-height: 30px;
      margin: 10px 5px;
      text-align: center;
    }
    .jb-bg {
      background-image: linear-gradient(#0479b4, #02407e);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/components/addTemperature.vue